import { IntegrationDisplayNameWarningAlert } from '@modules/integrationsV2/components/IntegrationDisplayNameWarningAlert';
import { Stack, TextField, TextFieldProps } from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { ChangeEvent } from 'react';
import { SnowflakeFormData } from './SnowflakeFormDrawerContent';

interface SnowflakeFormTextInputsProps {
  formData: SnowflakeFormData;
  handleTextInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  integrationType: IntegrationType;
  isReauthorizeForm: boolean;
}

export const SnowflakeFormTextInputs = ({
  formData,
  handleTextInputChange,
  isLoading,
  integrationType,
  isReauthorizeForm,
}: SnowflakeFormTextInputsProps) => {
  const commonTextFieldProps: Partial<TextFieldProps> = {
    onChange: handleTextInputChange,
    disabled: isLoading,
    variant: 'outlined',
    fullWidth: true,
  };

  if (isReauthorizeForm) {
    return (
      <>
        <TextField
          required
          label="Warehouse"
          name="warehouse"
          placeholder="Enter Warehouse"
          value={formData.warehouse}
          {...commonTextFieldProps}
        />
        <TextField
          label="User"
          name="user"
          placeholder="Enter User"
          value={formData.user}
          {...commonTextFieldProps}
        />
        <TextField
          label="Role"
          name="role"
          placeholder="Enter Role"
          value={formData.role}
          {...commonTextFieldProps}
        />
      </>
    );
  }

  return (
    <>
      <Stack spacing={1.5}>
        <TextField
          required
          label="Snowflake Integration Name"
          name="displayName"
          placeholder="Enter Integration Name"
          value={formData.displayName.value}
          error={!!formData.displayName.errorMessage}
          helperText={formData.displayName.errorMessage ?? undefined}
          {...commonTextFieldProps}
        />
        {integrationType === IntegrationType.Feedback && (
          <IntegrationDisplayNameWarningAlert />
        )}
      </Stack>
      <TextField
        required
        label="Account Name"
        name="accountName"
        placeholder="Enter Account Name"
        value={formData.accountName}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Database"
        name="database"
        placeholder="Enter Database"
        value={formData.database}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Schema"
        name="schema"
        placeholder="Enter Schema"
        value={formData.schema}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Warehouse"
        name="warehouse"
        placeholder="Enter Warehouse"
        value={formData.warehouse}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Table"
        name="table"
        placeholder="Enter Table"
        value={formData.table.value}
        error={!!formData.table.errorMessage}
        helperText={formData.table.errorMessage ?? undefined}
        {...commonTextFieldProps}
      />
      <TextField
        label="User"
        name="user"
        placeholder="Enter User"
        value={formData.user}
        {...commonTextFieldProps}
      />
      <TextField
        label="Role"
        name="role"
        placeholder="Enter Role"
        value={formData.role}
        {...commonTextFieldProps}
      />
    </>
  );
};
